import { ReactNode } from "react";
import { Card } from "./AvailableIntegrationCardWrapper.style";

type AvailableIntegrationCardWrapperProps = {
  children?: ReactNode;
};

export const AvailableIntegrationCardWrapper = (props: AvailableIntegrationCardWrapperProps) => {
  return <Card data-testid="up-card">{props.children}</Card>;
};
